import { render, staticRenderFns } from "./flowDeductionRecord.vue?vue&type=template&id=0f5e9f48&"
import script from "./flowDeductionRecord.vue?vue&type=script&lang=js&"
export * from "./flowDeductionRecord.vue?vue&type=script&lang=js&"
import style0 from "./flowDeductionRecord.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports